import MaintenanceIssueIndexVue from "@/views/maintenance-issue/MaintenanceIssueIndex.vue";

const maintenanceIssue = [
  {
    path: "/maintenance-issue",
    name: "maintenance-issue",
    component: MaintenanceIssueIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice"],
      public: false,
    },
  },
];

export default maintenanceIssue;
